import { MapInfoHeader as MapInfoHeaderUI } from 'ui-components'
import { useMap } from '~map-preview/states/map'

export const MapInfoHeader = () => {
  const map = useMap()
  return <MapInfoHeaderUI title={map?.name} />
}
